// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const LightningOutline = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 14 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M3.937 20.36c.041.022.099.02.134-.022l8.19-9.343a.101.101 0 0 0 .026-.098.112.112 0 0 0-.074-.082L8.143 9.504a.5.5 0 0 1-.323-.63l2.294-7.106a.106.106 0 0 0-.008-.083.108.108 0 0 0-.065-.055.11.11 0 0 0-.117.033l-8.187 9.34a.112.112 0 0 0 .009.157c.011.01.025.017.04.022l4.07 1.312a.5.5 0 0 1 .322.63L3.884 20.23a.113.113 0 0 0 .053.13Zm.054 1.015a1.123 1.123 0 0 1-.549-.147 1.12 1.12 0 0 1-.51-1.301l2.14-6.634-3.593-1.158a1.112 1.112 0 0 1-.495-1.792L9.17 1.005a1.111 1.111 0 0 1 1.895 1.068l-2.14 6.632 3.596 1.158c.359.117.63.403.729.765.103.36.014.747-.242 1.031l-8.181 9.334a1.102 1.102 0 0 1-.836.382Z"
			fill="#555BE4"
		/>
	</svg>
);
export default LightningOutline;
